import type { Theme } from '@mui/material';

export const styles = {
  wrapper: {
    height: '100%',
  },

  chatHistoryWrapper: {
    position: 'relative', // stacking context for the ErrorDisplay
    flexGrow: 1,
    overflow: 'hidden',
    pb: 2,
  },

  chatHistory: (theme: Theme) => ({
    height: '100%',
    overflowY: 'auto',
    color: theme.palette.common.black,
    px: 4.5,

    '> *:first-of-type': {
      pt: 2,
      '> *': {
        pt: 0,
      },
    },
  }),

  inputFieldArea: (theme: Theme) => ({
    flexGrow: 0,
    backgroundColor: theme.colors.white,
    pb: 2,
    px: 4.5,
  }),

  inputFieldOverline: {
    fontStyle: 'italic',
    fontWeight: 600,
  },

  textField: {
    overflowWrap: 'break-word',

    '& .MuiOutlinedInput-root': {
      px: 0,
      backgroundColor: 'inherit',
      '&:hover': {
        fieldset: {
          boxShadow: 'initial',
        },
      },
      '&.Mui-focused fieldset': {
        border: 0,
        boxShadow: 'initial',
      },
    },
  },

  spinner: {
    '.sk-spinner': {
      animation: 'sk-fade-in 0s',
      lineHeight: '10px',

      '> *': {
        width: '10px',
        height: '10px',
        animation: 'ball-beat 1s 0s infinite linear',

        '&:last-child': {
          animationDelay: '0.35s !important',
        },
      },
    },
  },
};
